const ARRL_SECTIONS = {
  "CT": { name: "Connecticut", type: "state", states: ["Connecticut"] },
  "DE": { name: "Delaware", type: "state", states: ["Delaware"] },
  "IL": { name: "Illinois", type: "state", states: ["Illinois"] },
  "IN": { name: "Indiana", type: "state", states: ["Indiana"] },
  "WI": { name: "Wisconsin", type: "state", states: ["Wisconsin"] },
  "MN": { name: "Minnesota", type: "state", states: ["Minnesota"] },
  "ND": { name: "North Dakota", type: "state", states: ["North Dakota"] },
  "SD": { name: "South Dakota", type: "state", states: ["South Dakota"] },
  "AR": { name: "Arkansas", type: "state", states: ["Arkansas"] },
  "LA": { name: "Louisiana", type: "state", states: ["Louisiana"] },
  "MS": { name: "Mississippi", type: "state", states: ["Mississippi"] },
  "TN": { name: "Tennessee", type: "state", states: ["Tennessee"] },
  "KY": { name: "Kentucky", type: "state", states: ["Kentucky"] },
  "MI": { name: "Michigan", type: "state", states: ["Michigan"] },
  "OH": { name: "Ohio", type: "state", states: ["Ohio"] },
  "IA": { name: "Iowa", type: "state", states: ["Iowa"] },
  "KS": { name: "Kansas", type: "state", states: ["Kansas"] },
  "MO": { name: "Missouri", type: "state", states: ["Missouri"] },
  "NE": { name: "Nebraska", type: "state", states: ["Nebraska"] },
  "ME": { name: "Maine", type: "state", states: ["Maine"] },
  "NH": { name: "New Hampshire", type: "state", states: ["New Hampshire"] },
  "RI": { name: "Rhode Island", type: "state", states: ["Rhode Island"] },
  "VT": { name: "Vermont", type: "state", states: ["Vermont"] },
  "AK": { name: "Alaska", type: "state", states: ["Alaska"] },
  "ID": { name: "Idaho", type: "state", states: ["Idaho"] },
  "MT": { name: "Montana", type: "state", states: ["Montana"] },
  "OR": { name: "Oregon", type: "state", states: ["Oregon"] },
  "NV": { name: "Nevada", type: "state", states: ["Nevada"] },
  "NC": { name: "North Carolina", type: "state", states: ["North Carolina"] },
  "SC": { name: "South Carolina", type: "state", states: ["South Carolina"] },
  "VA": { name: "Virginia", type: "state", states: ["Virginia"] },
  "WV": { name: "West Virginia", type: "state", states: ["West Virginia"] },
  "CO": { name: "Colorado", type: "state", states: ["Colorado"] },
  "NM": { name: "New Mexico", type: "state", states: ["New Mexico"] },
  "UT": { name: "Utah", type: "state", states: ["Utah"] },
  "WY": { name: "Wyoming", type: "state", states: ["Wyoming"] },
  "AL": { name: "Alabama", type: "state", states: ["Alabama"] },
  "GA": { name: "Georgia", type: "state", states: ["Georgia"] },
  "OK": { name: "Oklahoma", type: "state", states: ["Oklahoma"] },
  "AZ": { name: "Arizona", type: "state", states: ["Arizona"] },
  "PR": { name: "Puerto Rico", type: "territory", states: ["Puerto Rico"] },
  "VI": { name: "Virgin Islands", type: "territory", states: [] },
  
  "MDC": { 
    name: "Maryland-DC", 
    type: "state", 
    states: ["Maryland", "District of Columbia"] 
  },
  
  "EPA": {
    name: "Eastern Pennsylvania",
    type: "counties",
    state: "Pennsylvania",
    counties: ["Adams", "Berks", "Bradford", "Bucks", "Carbon", "Chester", "Columbia", "Cumberland", "Dauphin", "Delaware", "Juniata", "Lackawanna", "Lancaster", "Lebanon", "Lehigh", "Luzerne", "Lycoming", "Monroe", "Montgomery", "Montour", "Northampton", "Northumberland", "Perry", "Philadelphia", "Pike", "Schuylkill", "Snyder", "Sullivan", "Susquehanna", "Tioga", "Union", "Wayne", "Wyoming", "York"]
  },
  "WPA": {
    name: "Western Pennsylvania",
    type: "counties",
    state: "Pennsylvania",
    counties: ["Allegheny", "Armstrong", "Beaver", "Bedford", "Blair", "Butler", "Cambria", "Cameron", "Centre", "Clarion", "Clearfield", "Clinton", "Crawford", "Elk", "Erie", "Fayette", "Forest", "Franklin", "Fulton", "Greene", "Huntingdon", "Indiana", "Jefferson", "Lawrence", "McKean", "Mercer", "Mifflin", "Potter", "Somerset", "Venango", "Warren", "Washington", "Westmoreland"]
  },
  
  "NNY": {
    name: "Northern New York",
    type: "counties",
    state: "New York",
    counties: ["Clinton", "Essex", "Franklin", "Fulton", "Hamilton", "Jefferson", "Lewis", "Montgomery", "St. Lawrence", "Schoharie"]
  },
  "ENY": {
    name: "Eastern New York",
    type: "counties",
    state: "New York",
    counties: ["Albany", "Columbia", "Dutchess", "Greene", "Orange", "Putnam", "Rensselaer", "Rockland", "Saratoga", "Schenectady", "Sullivan", "Ulster", "Warren", "Washington", "Westchester"]
  },
  "NLI": {
    name: "NYC-Long Island",
    type: "counties",
    state: "New York",
    counties: ["Bronx", "Kings", "Nassau", "New York", "Queens", "Richmond", "Suffolk"]
  },
  "WNY": {
    name: "Western New York",
    type: "counties",
    state: "New York",
    counties: ["Allegany", "Broome", "Cattaraugus", "Cayuga", "Chautauqua", "Chemung", "Chenango", "Cortland", "Delaware", "Erie", "Genesee", "Herkimer", "Livingston", "Madison", "Monroe", "Niagara", "Oneida", "Onondaga", "Ontario", "Orleans", "Oswego", "Otsego", "Schuyler", "Seneca", "Steuben", "Tioga", "Tompkins", "Wayne", "Wyoming", "Yates"]
  },
  
  "NNJ": {
    name: "Northern New Jersey",
    type: "counties",
    state: "New Jersey",
    counties: ["Bergen", "Essex", "Hudson", "Hunterdon", "Middlesex", "Monmouth", "Morris", "Passaic", "Somerset", "Sussex", "Union", "Warren"]
  },
  "SNJ": {
    name: "Southern New Jersey",
    type: "counties",
    state: "New Jersey",
    counties: ["Atlantic", "Burlington", "Camden", "Cape May", "Cumberland", "Gloucester", "Mercer", "Ocean", "Salem"]
  },
  
  "EMA": {
    name: "Eastern Massachusetts",
    type: "counties",
    state: "Massachusetts",
    counties: ["Barnstable", "Bristol", "Dukes", "Essex", "Middlesex", "Nantucket", "Norfolk", "Plymouth", "Suffolk"]
  },
  "WMA": {
    name: "Western Massachusetts",
    type: "counties",
    state: "Massachusetts",
    counties: ["Berkshire", "Franklin", "Hampden", "Hampshire", "Worcester"]
  },
  
  "EWA": {
    name: "Eastern Washington",
    type: "counties",
    state: "Washington",
    counties: ["Adams", "Asotin", "Benton", "Chelan", "Columbia", "Douglas", "Ferry", "Franklin", "Garfield", "Grant", "Kittitas", "Klickitat", "Lincoln", "Okanogan", "Pend Oreille", "Spokane", "Stevens", "Walla Walla", "Whitman", "Yakima"]
  },
  "WWA": {
    name: "Western Washington",
    type: "counties",
    state: "Washington",
    counties: ["Clallam", "Clark", "Cowlitz", "Grays Harbor", "Island", "Jefferson", "King", "Kitsap", "Lewis", "Mason", "Pacific", "Pierce", "San Juan", "Skagit", "Skamania", "Snohomish", "Thurston", "Wahkiakum", "Whatcom"]
  },
  
  "EB": {
    name: "East Bay",
    type: "counties",
    state: "California",
    counties: ["Alameda", "Contra Costa", "Napa", "Solano"]
  },
  "SV": {
    name: "Sacramento Valley",
    type: "counties",
    state: "California",
    counties: ["Alpine", "Amador", "Butte", "Colusa", "El Dorado", "Glenn", "Lassen", "Modoc", "Nevada", "Placer", "Plumas", "Sacramento", "Shasta", "Sierra", "Siskiyou", "Sutter", "Tehama", "Trinity", "Yolo", "Yuba"]
  },
  "SF": {
    name: "San Francisco",
    type: "counties",
    state: "California",
    counties: ["Del Norte", "Humboldt", "Lake", "Marin", "Mendocino", "San Francisco", "Sonoma"]
  },
  "SJV": {
    name: "San Joaquin Valley",
    type: "counties",
    state: "California",
    counties: ["Calaveras", "Fresno", "Kern", "Kings", "Madera", "Mariposa", "Merced", "Mono", "San Joaquin", "Stanislaus", "Tulare", "Tuolumne"]
  },
  "SCV": {
    name: "Santa Clara Valley",
    type: "counties",
    state: "California",
    counties: ["Monterey", "San Benito", "San Mateo", "Santa Clara", "Santa Cruz"]
  },
  "LAX": {
    name: "Los Angeles",
    type: "counties",
    state: "California",
    counties: ["Los Angeles"]
  },
  "ORG": {
    name: "Orange",
    type: "counties",
    state: "California",
    counties: ["Inyo", "Orange", "Riverside", "San Bernardino"]
  },
  "SDG": {
    name: "San Diego",
    type: "counties",
    state: "California",
    counties: ["Imperial", "San Diego"]
  },
  "SB": {
    name: "Santa Barbara",
    type: "counties",
    state: "California",
    counties: ["San Luis Obispo", "Santa Barbara", "Ventura"]
  },
  
  "NFL": {
    name: "Northern Florida",
    type: "counties",
    state: "Florida",
    counties: ["Alachua", "Baker", "Bay", "Bradford", "Calhoun", "Citrus", "Clay", "Columbia", "Dixie", "Duval", "Escambia", "Flagler", "Franklin", "Gadsden", "Gilchrist", "Gulf", "Hamilton", "Hernando", "Holmes", "Jackson", "Jefferson", "Lafayette", "Lake", "Leon", "Levy", "Liberty", "Madison", "Marion", "Nassau", "Okaloosa", "Orange", "Putnam", "Santa Rosa", "Seminole", "St. Johns", "Sumter", "Suwannee", "Taylor", "Union", "Volusia", "Wakulla", "Walton", "Washington"]
  },
  "SFL": {
    name: "Southern Florida",
    type: "counties",
    state: "Florida",
    counties: ["Brevard", "Broward", "Collier", "Miami-Dade", "Glades", "Hendry", "Indian River", "Lee", "Martin", "Monroe", "Okeechobee", "Osceola", "Palm Beach", "St. Lucie"]
  },
  "WCF": {
    name: "West Central Florida",
    type: "counties",
    state: "Florida",
    counties: ["Charlotte", "DeSoto", "Hardee", "Highlands", "Hillsborough", "Manatee", "Pasco", "Pinellas", "Polk", "Sarasota"]
  },
  
  "NTX": {
    name: "North Texas",
    type: "counties",
    state: "Texas",
    counties: ["Anderson", "Archer", "Baylor", "Bell", "Bosque", "Bowie", "Brown", "Camp", "Cass", "Cherokee", "Clay", "Collin", "Comanche", "Cooke", "Coryell", "Dallas", "Delta", "Denton", "Eastland", "Ellis", "Erath", "Falls", "Fannin", "Franklin", "Freestone", "Grayson", "Gregg", "Hamilton", "Harrison", "Henderson", "Hill", "Hood", "Hopkins", "Hunt", "Jack", "Johnson", "Kaufman", "Lamar", "Lampasas", "Limestone", "McLennan", "Marion", "Mills", "Montague", "Morris", "Nacogdoches", "Navarro", "Palo Pinto", "Panola", "Parker", "Rains", "Red River", "Rockwall", "Rusk", "Shelby", "Smith", "Somervell", "Stephens", "Tarrant", "Throckmorton", "Titus", "Upshur", "Van Zandt", "Wichita", "Wilbarger", "Wise", "Wood", "Young"]
  },
  "STX": {
    name: "South Texas",
    type: "counties",
    state: "Texas",
    counties: ["Angelina", "Aransas", "Atascosa", "Austin", "Bandera", "Bastrop", "Bee", "Bexar", "Blanco", "Brazoria", "Brazos", "Brooks", "Burleson", "Burnet", "Caldwell", "Calhoun", "Cameron", "Chambers", "Colorado", "Comal", "Concho", "DeWitt", "Dimmit", "Duval", "Edwards", "Fayette", "Fort Bend", "Frio", "Galveston", "Gillespie", "Goliad", "Gonzales", "Grimes", "Guadalupe", "Hardin", "Harris", "Hays", "Hidalgo", "Houston", "Jackson", "Jasper", "Jefferson", "Jim Hogg", "Jim Wells", "Karnes", "Kendall", "Kenedy", "Kerr", "Kimble", "Kinney", "Kleberg", "La Salle", "Lavaca", "Lee", "Leon", "Liberty", "Live Oak", "Llano", "Madison", "Mason", "Matagorda", "Maverick", "McCulloch", "McMullen", "Medina", "Menard", "Milam", "Montgomery", "Newton", "Nueces", "Orange", "Polk", "Real", "Refugio", "Robertson", "Sabine", "San Augustine", "San Jacinto", "San Patricio", "San Saba", "Starr", "Travis", "Trinity", "Tyler", "Uvalde", "Val Verde", "Victoria", "Walker", "Waller", "Washington", "Webb", "Wharton", "Willacy", "Williamson", "Wilson", "Zapata", "Zavala"]
  },
  "WTX": {
    name: "West Texas",
    type: "counties",
    state: "Texas",
    counties: ["Andrews", "Armstrong", "Bailey", "Borden", "Brewster", "Briscoe", "Callahan", "Carson", "Castro", "Childress", "Cochran", "Coke", "Coleman", "Collingsworth", "Cottle", "Crane", "Crockett", "Crosby", "Culberson", "Dallam", "Dawson", "Deaf Smith", "Dickens", "Donley", "Ector", "El Paso", "Fisher", "Floyd", "Foard", "Gaines", "Garza", "Glasscock", "Gray", "Hale", "Hall", "Hansford", "Hardeman", "Hartley", "Haskell", "Hemphill", "Hockley", "Howard", "Hudspeth", "Hutchinson", "Irion", "Jeff Davis", "Jones", "Kent", "King", "Knox", "Lamb", "Lipscomb", "Loving", "Lubbock", "Lynn", "Martin", "Midland", "Mitchell", "Moore", "Motley", "Nolan", "Ochiltree", "Oldham", "Parmer", "Pecos", "Potter", "Presidio", "Randall", "Reagan", "Reeves", "Roberts", "Runnels", "Schleicher", "Scurry", "Shackelford", "Sherman", "Sterling", "Stonewall", "Sutton", "Swisher", "Taylor", "Terrell", "Terry", "Tom Green", "Upton", "Ward", "Wheeler", "Winkler", "Yoakum"]
  },
  
  "PAC": { name: "Pacific", type: "territory", states: ["Hawaii", "Guam", "American Samoa", "Northern Mariana Islands"] },
  
  "MX": { name: "Mexico", type: "country", country: "Mexico" },
  "DX": { name: "DX", type: "dx" },
  
  "NL": { name: "Newfoundland/Labrador", type: "canada", provinces: ["Newfoundland and Labrador"] },
  "NB": { name: "New Brunswick", type: "canada", provinces: ["New Brunswick"] },
  "NS": { name: "Nova Scotia", type: "canada", provinces: ["Nova Scotia"] },
  "PE": { name: "Prince Edward Island", type: "canada", provinces: ["Prince Edward Island"] },
  "QC": { name: "Quebec", type: "canada", provinces: ["Quebec"] },
  "ONE": { name: "Ontario East", type: "canada_region", province: "Ontario" },
  "ONN": { name: "Ontario North", type: "canada_region", province: "Ontario" },
  "ONS": { name: "Ontario South", type: "canada_region", province: "Ontario" },
  "GH": { name: "Golden Horseshoe", type: "canada_region", province: "Ontario" },
  "MB": { name: "Manitoba", type: "canada", provinces: ["Manitoba"] },
  "SK": { name: "Saskatchewan", type: "canada", provinces: ["Saskatchewan"] },
  "AB": { name: "Alberta", type: "canada", provinces: ["Alberta"] },
  "BC": { name: "British Columbia", type: "canada", provinces: ["British Columbia"] },
  "TER": { name: "Territories", type: "canada", provinces: ["Northwest Territories", "Nunavut", "Yukon"] }
};

export function getCountySection(stateName, countyName) {
  const cleanCounty = countyName.replace(/ County$/i, '').trim();
  
  for (const [code, section] of Object.entries(ARRL_SECTIONS)) {
    if (section.type === 'counties' && section.state === stateName) {
      if (section.counties.some(c => c.toLowerCase() === cleanCounty.toLowerCase())) {
        return code;
      }
    }
  }
  return null;
}

export function getStateSection(stateName) {
  for (const [code, section] of Object.entries(ARRL_SECTIONS)) {
    if (section.type === 'state' && section.states?.includes(stateName)) {
      return code;
    }
  }
  return null;
}

export function getCanadaSection(provinceName) {
  for (const [code, section] of Object.entries(ARRL_SECTIONS)) {
    if (section.type === 'canada' && section.provinces?.includes(provinceName)) {
      return code;
    }
  }
  return null;
}

export function getCountrySection(countryName) {
  for (const [code, section] of Object.entries(ARRL_SECTIONS)) {
    if (section.type === 'country' && section.country === countryName) {
      return code;
    }
  }
  return null;
}

export function getSectionInfo(code) {
  return ARRL_SECTIONS[code] || null;
}

export function getAllSectionCodes() {
  return Object.keys(ARRL_SECTIONS);
}

export const SPLIT_STATES = ['Pennsylvania', 'New York', 'New Jersey', 'Massachusetts', 'Washington', 'California', 'Florida', 'Texas'];

export default ARRL_SECTIONS;
